import axios from "axios";

export class NotificationMessagesService {
    getNotificationMessage(){
        return axios.get('/appapv/getNotificationMessage.action', {
            headers: {'Content-Type': 'application/json',},
            params: {}
        }).then(res => res.data);
    }

    getDetailNotificationMessage(idNotification){
        return axios.get('/appapv/getDetailNotificationMessage.action', {
            headers: {'Content-Type': 'application/json',},
            params: {
                id: idNotification ? idNotification : ""
            }
        }).then(res => res.data);
    }

    acceptNotificationMessage(idNotification){
        return axios.post('/appapv/acceptNotificationMessage.action', {}, {
            params: {
                id: idNotification ? idNotification : ""
            }
        }).then(res => res.data);
    }
}